<template>
  <div>
    <div class="filter-container">
      <el-card shadow="never" class="custom-card">
        <el-input v-model="queryParam.VersionName" style="width: 200px" class="filter-item" placeholder="版本名称"/>
        <el-button type="primary" icon="el-icon-search" round class="filter-item" @click="getList">搜索</el-button>
        <el-button type="danger" round class="filter-item" icon="el-icon-circle-plus-outline" @click="handleAdd">添加</el-button>
      </el-card>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      fit
      stripe
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="版本名称" prop="VersionName"/>
      <el-table-column label="版本号" prop="VersionCode"/>
      <el-table-column label="更新包路径" prop="VersionPath"/>
      <el-table-column label="更新内容" prop="VersionDesc"/>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <el-popconfirm
            title="确定删除吗？"
            @onConfirm="del(row)"
          >
            <el-link slot="reference" type="danger">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <el-card class="custom-card" shadow="never">
      <el-pagination
        v-show="total>0"
        :current-page="pageIndex"
        :page-sizes="[10,20,50,100]"
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <create-form
      v-if="visible"
      ref="createModal"
      @close="visible = false"
      @refresh="getList"
    />
  </div>
</template>

<script>
import { qrySoftVersion, delSoftVersion } from './api'
import CreateForm from './components/CreateForm.vue'
export default {
  components: { CreateForm },
  data() {
    return {
      listLoading: true,
      visible: false,
      activeName: 'shu',
      queryParam: {
        'VersionPath': null,
        'VersionCode': null,
        'VersionName': null,
        'VersionDesc': null
      },
      list: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.getList()
  },
  methods: {
    del(row) {
      console.log(`ceshi`, row)
      delSoftVersion({ Id: row.VersionId }).then(res => {
        this.getList()
      })
    },
    handleAdd() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.createModal.init()
      })
    },
    getList() {
      qrySoftVersion(Object.assign(this.queryParam, {
        current: this.pageIndex,
        size: this.pageSize
      })).then(res => {
        console.log(res)
        this.list = res.LsList
        this.total = res.TotalRows
      }).finally(() => {
        this.listLoading = false
      })
    },
    handleSizeChange(e) {
      this.pageSize = e
      this.getList()
    },
    handleCurrentChange(e) {
      this.pageIndex = e
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .el-tabs{
    background-color: white;
    padding: 0 15px;
  }
}
</style>
